import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Button, FileUploader } from 'carbon-components-react';
import moment from 'moment';
import { StepCard } from '../../index';
import { getDmService, deleteDmService } from '../../../services/Api';
// import appConfig from '../../../config/app-config';
import { forceDownloadAsync } from '../../../lib/validations';

// const { IMAGE_PATHV2, IMAGE_PATH } = appConfig;



class UploadReference extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isFinished: false,
      advanced: false,
      uploads: [],
      idUrl: null
    }
  }

  componentDidMount = () => {
    this.loadProductRequest()
    this.loadUploads()
  }

  componentDidUpdate = async (prevProps) => {
    const { match, dataRequest } = this.props;
    const { idUrl } = this.state;

    if (idUrl !== match.params.id) {
      await this.setState({
        idUrl: match.params.id,
        isFinished: false
      })
      this.loadUploads();
      this.loadProductRequest();
    }

    // Check if dataRequest updated (e.g. loaded asynchronously)
    if (prevProps.dataRequest !== dataRequest) {
      this.loadUploads();
      this.loadProductRequest();
    }
  }

  renderDescription = () => {
    const { uploads } = this.state;


    if (uploads && uploads.length) {
      return uploads.map((item, index) => (
        <div key={index}>
          <strong>
            {`${item.name}`}
          </strong>
          <br />
          <strong className='data-upload'>{item.dataupload ? ` ↑ Data Upload: ${moment(item.dataupload).format('DD/MM/YYYY [às] HH:mm')}` : ''}</strong>
        </div>
      ))
    }
    return (
      <p className="description">
        <strong>Não esqueça de enviar referências visuais!</strong>
        Elas ajudam a traduzir a sua ideia e o que você espera da entrega.
      </p>
    )
  }

  removeUpload = async (index, id) => {
    try {
      if (id)
        await deleteDmService('/Pedido/DeleteArquivoReferencia', [id]);
      await this.setState(prevState => {
        const newList = [...prevState.uploads];
        newList.splice(index, 1);
        return { uploads: newList };
      });
    } catch (error) {
      toast.error("Ocorreu uma falha ao excluir o arquivo");
    }
  }

  advance = async () => {
    const { saveStep } = this.props;
    const { uploads } = this.state;
    if (uploads.length) {
      await saveStep({
        uploads
      })
      await this.setState({ isFinished: true })
      // await this.stepCardRef.toggleContent();
    } else {
      this.setState({ isFinished: false })
      toast.warn("Você esqueceu de fazer o upload.")
    }

  }

  cancel = () => {
    this.stepCardRef.toggleContent();
  }

  fileChange = async (name) => {
    const { files } = document.getElementsByName(name)[0];
    await this.setState(prevState => {
      const uploads = prevState.uploads || [];
      for (let i = 0; i < files.length; i++) uploads.push(files[i]);
      return { ...prevState, uploads };
    });
    await this.advance();
  }

  renderOptional = () => {
    const { dataProduct } = this.props;
    const { dataFilters } = dataProduct;

    if (dataFilters && !dataFilters.uploadReferencia) {
      return (
        <span className="optional"> (opcional) </span>
      )
    }

    return ""

  }


  loadProductRequest = async () => {
    const { dataRequest, productSave } = this.props;
    const { idProduto } = dataRequest;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");

    try {
      let nameProduct = ""
      if (existRequest && !productSave) {
        const data = await getDmService(`/Pedido/GetNomeProduto/?grupo=${dataRequest.idGrupo}`);
        const idsSearch = data.find(item => parseInt(item.id, 10) === parseInt(idProduto, 10))
        nameProduct = idsSearch.nome
      } else {
        nameProduct = productSave !== undefined ? productSave.label : "";
      }

      this.setState({
        nameProduct
      });

    } catch (error) {
      console.log(error)
    }
  }

  loadUploads = () => {
    const { dataProduct, dataRequest } = this.props;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");
    let uploadsReferenci = [];

    // Check if we have references from the API, regardless of existRequest check which might be flaky
    const hasApiReferences = dataRequest && dataRequest.referencias && dataRequest.referencias.length > 0;

    // Prioritize loading from referrals if they exist and no local uploads have been set yet
    if ((existRequest || hasApiReferences) && !dataProduct.uploads && hasApiReferences) {
      uploadsReferenci = dataRequest.referencias.map(item => {
        let name = item.imagem;
        if (name && name.includes('/')) {
          name = name.split('/').pop();
        }
        return {
          id: item.id,
          name: name,
          downloadPath: item.imagem,
          dataupload: item.dataUpload,
        };
      })
    } else if (dataProduct.uploads) {
      uploadsReferenci = dataProduct.uploads
    }

    this.setState({
      uploads: uploadsReferenci
    })
  }

  render() {
    const { isFinished, advanced, uploads, nameProduct } = this.state;
    const { disabledCard, dataRequest } = this.props;
    const existRequest = Object.prototype.hasOwnProperty.call(dataRequest, "idGrupo");

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title="Upload de Referências"
        optional={this.renderOptional()}
        description={this.renderDescription()}
        isFinished={isFinished || existRequest}
        onToogle={advanced}
      >
        <div className="row">
          <div className="bx--col-md-12 bx--col-xs-12">
            <p className="description">
              Somente as seguintes extensões são permitidas:
              <br />
              .jpg, .png, .gif, .jpeg, .bmp, .mp3, .mp4, .wmv, .pdf, .docx,  .doc, .pptx, .ppt, .psd, .ai, .eps, .cdr, .xls, .xlsx, .svg
            </p>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-md-12 bx--col-xs-12">
            <label className="bx--label">
              {nameProduct}
            </label>
            <p className="description">
              Referências para
              {' '}
              {nameProduct}
            </p>
            {!disabledCard && (
              <FileUploader
                id="reference"
                className="upload-referecy-agency"
                labelDescription=""
                buttonLabel="Adicionar"
                filenameStatus="edit"
                onChange={() => {
                  this.fileChange("reference");
                }}
                kind="secondary"
                multiple
                ref={fileUploader => (this.fileUploader = fileUploader)}
                accept={['.jpg', '.png', '.gif', '.jpeg', '.bmp', '.mp3', '.mp4', '.wmv', '.pdf', '.docx', '.doc', '.pptx', '.ppt', '.psd', '.ai', '.cdr', '.xls', '.xlsx', '.eps', '.svg']}
                name="reference"
              />
            )}

            {uploads && uploads.length > 0 && uploads.map((item, index) => (
              <div key={index} className="bx--file-container ">
                <span className="bx--file__selected-file" id="reference" kind="secondary">
                  <a
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (item.id) {
                        forceDownloadAsync(item.downloadPath || item.name);
                      } else {
                        window.open(URL.createObjectURL(uploads[0]), '_blank');
                      }
                    }}
                    alt="Uploads"
                  >
                    {item.name}
                  </a>
                  {!disabledCard && (
                    <i
                      className="item-upload-close pointer"
                      onClick={() => this.removeUpload(index, item.id)}
                    >
                      close
                    </i>
                  )}

                </span>
              </div>
            ))
            }
          </div>
        </div>
        {!disabledCard && false && (
          <div className="bx--row">
            <div className="bx--col-xs-12 bx--col-md-12 v-md-margin">
              <Button
                onClick={this.advance}
                className="bx--btn btn-secondary-color"
              >
                Avançar
              </Button>
              <Button
                kind="ghost"
                className="bx--btn btn-secondary-outlined h-sm-margin"
                onClick={this.cancel}
              >
                Cancelar
              </Button>
            </div>
          </div>
        )}

      </StepCard>
    )
  }
}

export default UploadReference;



// WEBPACK FOOTER //
// ./src/components/agency/requests/UploadReference.js